"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _FlipNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/FlipNugget"));

var _DrupalFlipNugget = _interopRequireDefault(require("./DrupalFlipNugget.scss"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _index = require("../../../../KESI2/Services/RemoteControlService/index");

var _FeatureManager = _interopRequireDefault(require("../../../../utils/features/FeatureManager"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _FeedbackService = require("../../../../KESI2/Services/FeedbackService");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _Constants = require("../../../constants/Constants");

var _DrupalNuggetStrings = require("./DrupalNuggetStrings");

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _TimeoutHelper = require("../../../../helpers/TimeoutHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'flipContainer_';

var DrupalFlipNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalFlipNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalFlipNugget);

  function DrupalFlipNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalFlipNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "flipImage", function (id) {
      var clicked = _this.state.clicked;
      var flipped = _this.state.checkIfFlipped;
      flipped[id] = true; // check if every image was at least flipped once -> if yes: mark nugget as read

      var flippedEverything = (0, _keys["default"])(flipped).every(function (key) {
        return flipped[key];
      });

      if (flippedEverything) {
        if (!_this.props.inSwipeContainer) {
          _this.props.markAsRead(_this.props.id);
        }
      }

      clicked[id] = !clicked[id];

      _this.setState({
        clicked: clicked,
        checkIfFlipped: flipped
      });

      _this.forceUpdate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getClassNames", function (id) {
      if (_this.state.clicked[id]) {
        return "".concat(_DrupalFlipNugget["default"].card, " ").concat(_this.isInternetExplorer ? _DrupalFlipNugget["default"].flipped2 : _DrupalFlipNugget["default"].flipped);
      } else {
        return "".concat(_DrupalFlipNugget["default"].card);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getWidthAndMargin", function (index, elem) {
      var nugget = _this.state.content[_this.props.id];
      var el = document.getElementById(elem);
      var elemWidthPx = el ? el.offsetWidth : '800px';
      var elemWidth = (0, _parseInt2["default"])(elemWidthPx, 10);
      var img = document.getElementById("card_".concat(index, "_img_back_").concat(_this.props.id));
      var heightRatio = 3;
      var widthRatio = 4;
      var ratio = 0.75;

      if (img) {
        if (!img.offsetHeight) {
          img = img.cloneNode(false);
        }

        widthRatio = img.offsetWidth;
        heightRatio = img.offsetHeight;
        ratio = heightRatio / widthRatio;
      }

      var columns = nugget.mobileColumns && window.innerWidth < _Constants.SMARTPHONE_WIDTH_PORTRAIT_BREAKPOINT ? nugget.mobileColumns : nugget.columns;

      if (columns === 1) {
        return {
          width: '100%',
          marginBottom: '5%',
          height: "".concat(elemWidth * ratio, "px")
        };
      }

      if (columns === 2) {
        if (index % columns !== 0) {
          return {
            width: "".concat(100 / columns - (columns - 1) * 3, "%"),
            marginLeft: "".concat(columns * 3, "%"),
            marginBottom: "".concat(columns * 3, "%"),
            height: "".concat(elemWidth * ((100 / columns - (columns - 1) * 3) / 100) * ratio, "px")
          };
        } else {
          return {
            width: "".concat(100 / columns - (columns - 1) * 3, "%"),
            marginBottom: "".concat(columns * 3, "%"),
            height: "".concat(elemWidth * ((100 / columns - (columns - 1) * 3) / 100) * ratio, "px")
          };
        }
      }

      if (columns < 5) {
        if (index % columns !== 0) {
          return {
            width: "".concat(100 / columns - (columns - 1) * 2, "%"),
            marginLeft: "".concat(columns * 2, "%"),
            marginBottom: "".concat(columns * 2, "%"),
            height: "".concat(elemWidth * ((100 / columns - (columns - 1) * 2) / 100) * ratio, "px")
          };
        } else {
          return {
            width: "".concat(100 / columns - (columns - 1) * 2, "%"),
            marginBottom: "".concat(columns * 2, "%"),
            height: "".concat(elemWidth * ((100 / columns - (columns - 1) * 2) / 100) * ratio, "px")
          };
        }
      }

      if (columns < 8) {
        if (index % columns !== 0) {
          return {
            width: "".concat(100 / columns - (columns - 1), "%"),
            marginLeft: "".concat(columns, "%"),
            marginBottom: "".concat(columns * 2, "%"),
            height: "".concat(elemWidth * ((100 / columns - (columns - 1)) / 100) * ratio, "px")
          };
        } else {
          return {
            width: "".concat(100 / columns - (columns - 1), "%"),
            marginBottom: "".concat(columns * 2, "%"),
            height: "".concat(elemWidth * ((100 / columns - (columns - 1)) / 100) * ratio, "px")
          };
        }
      }

      if (index % columns !== 0) {
        return {
          width: "".concat(100 / columns - (columns - 1) / 2, "%"),
          marginLeft: "".concat((columns - 1) / 2, "%"),
          marginBottom: "".concat((columns - 1) / 2, "%"),
          height: "".concat(elemWidth * ((100 / columns - (columns - 1) / 2) / 100) * ratio, "px")
        };
      } else {
        return {
          width: "".concat(100 / columns - (columns - 1) / 2, "%"),
          marginBottom: "".concat((columns - 1) / 2, "%"),
          height: "".concat(elemWidth * ((100 / columns - (columns - 1) / 2) / 100) * ratio, "px")
        };
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sortFlipImages", function (contents) {
      if (_config["default"].sortById) {
        return contents.sort(function (content1, content2) {
          return content1.id - content2.id;
        });
      }

      if (_config["default"].sortByOrderField) {
        return contents.sort(function (content1, content2) {
          if ((content1.order || content1.order === 0) && (content2.order || content2.order === 0)) {
            if (content1.order < content2.order) {
              return -1;
            }

            if (content1.order > content2.order) {
              return 1;
            }

            return 0;
          } else {
            // Don't bring up id sorting here!
            // This piece of code is used for lecture-in-spoc sorting, too and we want to keep the author's order there
            return 0;
          }
        });
      }

      return contents;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "replaceHrefs", function (htmlStr) {
      var newStr = htmlStr.replace(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/g, function (match, p1, p2) {
        // do not replace mailto links etc
        if (match.indexOf('http') !== -1) {
          return "<a href=\"javascript:;\" onclick=\"window.open('".concat(p2, "', '_system')\"");
        }

        return match;
      });
      return newStr;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleImageLoaded", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var nugget;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nugget = _this.state.content[_this.props.id];

              if (_this.state.imgLoaded) {
                _context.next = 7;
                break;
              }

              _this.loadedImages++;

              if (!(_this.loadedImages === nugget.flipImages.length)) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return (0, _TimeoutHelper.timeout)(100);

            case 6:
              _this.setState({
                imgLoaded: true
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = _objectSpread({
      clicked: null,
      checkIfFlipped: null,
      waitingForActivation: false,
      imgLoaded: false
    }, _this.state);
    _this.loadedImages = 0;
    _this.active = true; // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.props.registerNugget(_this.props.id, _FlipNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    _this.isInternetExplorer = _DeviceInfoHelper["default"].isInternetExplorer();
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalFlipNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalFlipNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _FlipNugget["default"].CLASS, this.getDomId());
      var nugget = this.state.content[this.props.id];
      var clicked = {};
      var flipped = {};
      nugget.flipImages.forEach(function (image) {
        clicked[image.id] = false;
        flipped[image.id] = false;
      });
      this.setState({
        clicked: clicked,
        checkIfFlipped: flipped
      });

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalFlipNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
    /*
    componentWillUpdate (newProps, newState) {
      const nugget = newState.content[this.props.id]
       const active = DataStore.pathExists(`${this.props.id}.${this.props.contentPathArray.join(KESI_PATH_DELIMITER)}`, newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES])
        ? newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(KESI_PATH_DELIMITER)]
        : nugget.active
       if (newState.waitingForActivation && active !== this.active) {
        newState['waitingForActivation'] = false
      }
    }
    */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {FlipNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var sortedFlipImages = this.sortFlipImages(nugget.flipImages);
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var nuggetIcon = _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null;
      var replacedInfo = nugget.info ? this.replaceHrefs(nugget.info) : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "flipContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, nuggetIcon, /*#__PURE__*/_react["default"].createElement("div", {
        id: "flipContainer_".concat(this.props.id),
        className: "FlipNugget_".concat(this.props.id, " ").concat(nugget.theme, " fliparea ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "title"
      }, nugget.title) : null, nugget.info && /*#__PURE__*/_react["default"].createElement("div", {
        className: "info ".concat(_Nugget["default"].info),
        dangerouslySetInnerHTML: {
          __html: replacedInfo
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flipNuggetContainer ".concat(nugget.title && nugget.show_title ? '' : 'extraPadding')
      }, this.state.clicked && sortedFlipImages && sortedFlipImages.length > 0 && sortedFlipImages.map(function (image, index) {
        if (!image) {
          return null;
        }

        var imgClassNames = _this2.getClassNames(image.id);

        var margins = _this2.getWidthAndMargin(index, "flipContainer_".concat(_this2.props.id));

        var frontPath = _DeviceInfoHelper["default"].isBrowser() ? image.frontside.url : "".concat(_this2.props.path).concat(image.frontside);
        var backPath = _DeviceInfoHelper["default"].isBrowser() ? image.backside.url : "".concat(_this2.props.path).concat(image.backside);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalFlipNugget["default"].flip,
          key: "card_".concat(index),
          style: margins
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: "card_".concat(index),
          className: "".concat(imgClassNames)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_DrupalFlipNugget["default"].face, " ").concat(_DrupalFlipNugget["default"].front),
          style: {
            transformOrigin: "100% ".concat(margins.height / 2)
          },
          onClick: function onClick() {
            return _this2.flipImage(image.id);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: 'Vorderseite FlipImage',
          id: "card_".concat(index, "_img_front_").concat(_this2.props.id),
          src: frontPath,
          onLoad: _this2.handleImageLoaded
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_DrupalFlipNugget["default"].face, " ").concat(_DrupalFlipNugget["default"].back),
          style: {
            transformOrigin: "100% ".concat(margins.height / 2)
          },
          onClick: function onClick() {
            return _this2.flipImage(image.id);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: 'Rückseite FlipImage',
          id: "card_".concat(index, "_img_back_").concat(_this2.props.id),
          src: backPath
        }))));
      }))), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalFlipNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalFlipNugget;
DrupalFlipNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  renderIcon: _propTypes["default"].func.isRequired,
  setLike: _propTypes["default"].func
};
DrupalFlipNugget.defaultProps = {
  id: null
};